import { Field } from 'formik';

import styled from 'styled-components';
import { Link as RouterDomLink } from 'react-router-dom';

// Containers
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
`;

export const MenuContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 30%;
  min-width: 560px;
  border-radius: 0 30px 30px 0;
  background-color: white;
  flex-direction: column;
  position: absolute;
  align-items: space-between;

  @media (max-width: 500px) {
    max-width: 100%;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: flex-end;
`;

export const BackgroundImage = styled.img`
  height: 100%;
  min-width: calc(100vw - 450px);
  object-fit: cover;
`;

export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  height: max-content;
  align-items: center;
  flex-direction: column;
  justify-content: flex-end;
  /* 
  @media (max-height: 900px) {
    min-height: 80vh;
  } */
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const FooterContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-bottom: 2.5rem;
  flex-direction: column;
  justify-content: flex-end;
`;

export const LinkContainer = styled.div`
  min-width: max-content;
  display: flex;
  justify-content: space-between;
  gap: 18px;
`;

export const Logo = styled.img`
  max-width: 340px;
  width: 100%;
  height: auto;
  margin-bottom: 50px;
`;

export const Text = styled.p`
  font-size: 14px;
`;

export const CenterText = styled(Text)`
  text-align: center;
`;

export const Link = styled.a`
  color: black;
  font-size: 14px;
`;

export const FooterLink = styled(Link)`
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  color: #4948ac;
`;

export const FooterRouteLink = styled(RouterDomLink)`
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  color: #4948ac;
`;

export const FormTitle = styled.h3`
  text-transform: uppercase;
  margin: 0;
  text-align: center;
`;

export const ErrorText = styled(Text)`
  color: red;
`;

export const ErrorContainer = styled.div`
  min-height: 26px;
  max-width: 400px;
  margin: 14px 0 20px 0;
`;

export const FooterText = styled(Text)`
  font-size: 12px;
  font-weight: 400;
`;

// Inputs
export const FormInputWrapper = styled.div`
  &:first-child {
    margin-bottom: 22px;
  }
`;

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 11px;
`;

export const LoginInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 44px;
  width: 400px;
`;

export const Input = styled(Field)`
  max-width: 100%;
  height: 100%;
  width: 100%;
  padding: 0 80px 0 42px;
  font-weight: bold;
  border: 1px solid #c9cbd3;
  border-radius: 4px;
  &::placeholder {
    color: #9399b2;
    font-weight: 400;
  }
`;

export const InputIcon = styled.img`
  position: absolute;
  height: auto;
`;

export const EmailIcon = styled(InputIcon)`
  width: 18px;
  left: 16px;
`;

export const LockIcon = styled(InputIcon)`
  width: 14px;
  left: 16px;
`;

export const QuestionIcon = styled(InputIcon)`
  width: 22px;
  right: 16px;
  bottom: 50%;
  transform: translateY(50%);
  cursor: pointer;
`;

export const CloseIcon = styled(QuestionIcon)`
  width: 14px;
  align-self: flex-end;
`;

export const ShowPassword = styled.img`
  position: absolute;
  width: 25px;
  right: 48px;
  padding: 5px 0px;
  cursor: pointer;
`;

export const SignUpText = styled.p`
  font-size: 13px;
  margin: 4px;
  padding: 0;
`;
